import React from 'react';
import { useTranslation } from 'react-i18next';

const SearchDidYouMean = ({ suggestedKey, onSelectKey }) => {
    const { t } = useTranslation('common');

    if (!suggestedKey) return null;

    return (
        <div
            className="mb-4 p-3 border-0 shadow-sm transition-all"
            style={{
                background: 'linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%)',
                borderRadius: '16px',
                borderRight: '5px solid #ffc107',
                boxShadow: '0 4px 20px rgba(255, 193, 7, 0.15)'
            }}
        >
            <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="d-flex align-items-center mb-2 mb-sm-0">
                    <div
                        className="rounded-circle d-flex align-items-center justify-content-center ml-3"
                        style={{ width: '40px', height: '40px', backgroundColor: '#ffe8a1', color: '#856404' }}
                    >
                        <i className="fas fa-sparkles text-warning font-size-h5"></i>
                    </div>
                    <div className="h5 mb-0 text-dark">
                        <span className="text-muted font-weight-normal ml-1">
                            {t('Pages.Search.DidYouMean', 'هل تقصد:')}
                        </span>{' '}
                        <button
                            type="button"
                            className="btn btn-link p-0 text-primary font-weight-bold h5 mb-0 align-baseline w-auto"
                            style={{ textDecoration: 'none', fontSize: '1.1rem' }}
                            onClick={() => onSelectKey(suggestedKey)}
                        >
                            "{suggestedKey}"
                        </button>
                    </div>
                </div>
                <button
                    className="btn btn-warning text-dark font-weight-bold px-4 py-2 w-auto"
                    style={{ borderRadius: '25px', boxShadow: '0 4px 12px rgba(255,193,7,0.3)' }}
                    onClick={() => onSelectKey(suggestedKey)}
                >
                    <i className="fas fa-magnifying-glass ml-2"></i>
                    {t('Pages.Search.SearchFor', 'بحث عن')} "{suggestedKey}"
                </button>
            </div>
        </div>
    );
};

export default SearchDidYouMean;
